export enum QueryKeys {
  USER = "user",
  CRMs = "CRM's",
  CUSTOMERBI = "customer-bi",
  EXPENSE_CARDS_CHART_CARD_INACTIVE = "expense-cards/chart-card-inactive",
  DASHBOARDBI = "dashboardBI",
  AIRLINES = "airlines",
  BALANCE_NO_TRANSACTION = "expense/balance-no-transaction",
  CUSTOMERS = "agency/customers",
  AGENCIES = "agencies",
  CREDENTIALS = "credentials",
  CARDS = "cards",
  VEHICLE_TRAVELERS = "vehicle/vehicle-travelers",
  HOTEL_TRAVELERS = "hotel/hotel-travelers",
  AIRWAY_TRAVELERS = "airway/airway-travelers",
  ROAD_TRAVELERS = "road/road-travelers",
  CARD_FLAGS = "card-flags",
  AGREEMENTS = "agreements",
  CURRENT_TIME = "current-time",
  ORDER_MESSAGES = "order/messages",
  PROVIDERS = "providers",
  ORDER_HISTORY = "order/history",
  APPROVERS = "aprovers",
  AGENCY = "agency",
  GROUPS = "groups",
  CUSTOMER = "customer",
  EXPENSE_CATEGORIES = "expense-categories",
  INTERVENTIONS = "dashboardBI/interventions",
  LOGOUT_CUSTOMERS = "dashboardBI/logoutCustomers",
  NEW_CLIENTS_PURCHASE_MONTH = "dashboardBI/newClientsPurchaseMonth",
  NOT_BUYING_CUSTOMERS = "dashboardBI/notBuyingCustomers",
  PENDING_FIRST_PURCHASE = "dashboardBI/pendingFirstPurchase",
  ORDERS_NOT_ISSUED_WEEK = "dashboardBI/ordersNotIssuedWeek",
  POLICY_PARAMETER_EXPENSES = "policy-parameter-expenses",
  POLICY_PARAMETER_ADVANCES = "policy-parameter-advances",
  AGENCY_EMPLOYEES = "agency/agency-employees",
  AGENCY_FEES = "agency/agency-fees",
  AGENCY_MARKDOWNS = "agency/markdowns",
  AGENCY_MARKUPS = "agency/markups",
  CUSTOMER_JUSTIFICATIONS = "customer/customer-justifications",
  CUSTOMER_CREDENTIAL = "customer/credentials",
  CUSTOMER_REASON_TRIPS = "customer/customer-reason-trips",
  CUSTOMER_COST_CENTERS = "customer/customer-cost-centers",
  CUSTOMER_EXPENSE_TYPES = "customer/customer-expense-types",
  CUSTOMER_EMPLOYEES = "customer/customer-employees",
  CUSTOMER_EMPLOYEE_TRANSACTIONS = "customer-employee/transactions",
  CUSTOMER_POLICIES = "customer/policies",
  CUSTOMER_EXPENSE_POLICIES = "customer/expense-policies",
  CUSTOMER_EXPENSE_VIOLATED_POLICIES = "customer/expense-violated-policies",
  CUSTOMER_ADVANCE_POLICIES = "customer/advance-policies",
  CUSTOMER_FORBIDDEN_EXPENSE_ITEMS = "customer/forbidden-expense-items",
  CUSTOMER_BRANCHES = "customer/branches",
  CUSTOMER_APPROVAL_MODELS = "customer/approval-models",
  CUSTOMER_APPROVAL_MODEL = "customer/approval-model",
  CUSTOMER_INVOICES = "customer/invoices",
  STATE_CITIES = "state/cities",
  CUSTOMER_ORDERS = "customer/orders",
  CUSTOMER_ORDERS_INFINITE = "customer/orders-infinite",
  AGENCY_PENDING_ORDERS = "agency/pending-orders",
  ORDERS = "orders",
  ORDER_ACCOUNTABILITY_EXPENSES = "order/accountability-expense",
  ORDER_HOTEL = "order/hotel",
  ORDER_AIRWAY = "order/airway",
  ORDER_VEHICLE = "order/vehicle",
  ORDER_ROAD = "order/road",
  ORDER_ADVANCE = "order/advance",
  ORDER_EXPENSE = "order/expense",
  QUERY_ROAD = "query/road",
  QUERY_HOTEL = "query/hotel",
  QUERY_FLIGHTS = "query/flights",
  HOTEL = "booking/hotels",
  QUERY_HOTEL_DETAILS = "query/hotel-details",
  QUERY_VEHICLE = "query/vehicle",
  HOTEL_DETAILS = "booking/hotel/details",
  QUERY_HOTEL_ROOM_RULES = "query/hotel-rules",
  HOTEL_ROOM_RULES = "booking/hotel/rules",
  ROADS_GO = "booking/roads/go",
  SUMMARY = "booking/summary/",
  ROADS_RETURN = "booking/roads/return",
  QUERY_LINKS_FLIGHTS = "query-links/flights",
  QUERY_FLIGHTS_GO = "query/flights/departure",
  QUERY_FLIGHTS_RETURN = "query/flights/arrival",
  CUSTOMER_SETTING_PARAMETERS = "customer/setting-parameters",
  AGENCY_SETTING_PARAMETERS = "agency/setting-parameters",
  SETTING_PARAMETERS = "setting-parameters",
  MARKUP_PER_SUPLIER = "markup-per-suplier",
  REORDER = "reorder",
  PROJECTS = "customer/projects",
  PHASES = "customer/projects/phases",
  BUDGETS = "customer/budgets",
  BUDGETS_VIEW = "customer/budgets/view",
  ORDER_BUDGET_BALANCE = "order/budget-balance",
  QUERY_VEHICLE_DETAILS = "query/vehicle-details",
  QUERY_VEHICLE_LINKS = "query/vehicle-links",
  QUERY_VEHICLE_MONTHLY_OPTIONS = "query/vehicle-monthly-options",
  HOTEL_OFF_PAYMENT_METHOD = "hotel-offline-payment-mathod",
  PAYMENT_METHODS = "payment-methods",
  OFFLINE_HOTEL = "offline-hotel",
  OFFLINE_HOTELS = "offline-hotels",
  OFFLINE_HOTEL_ROOM = "offline-hotel-room",
  OFFLINE_HOTEL_ROOMS = "offline-hotel-rooms",
  AMENITIES = "amenities",
  CUSTOMER_EMPLOYEES_GROUPS = "customer/customer-employees-groups",
  GROUP_EMPLOYEES = "customer/group-employees",
  ORDERS_SUMMARY = "orders/summary",
  COST_CATEGORIES = "cost-categories",
  UNFLOWN_AIRWAYS = "unflown-airways",
  UNFLOWN_AIRWAYS_METRICS = "unflown-airways/metrics",
  UNFLOWN_AIRWAYS_SUMMARY = "unflown-airways/summary",
  REASON_EXPENSES = "customer/reason-expenses",
  EMPLOYEE_EXPENSES = "employee/expenses",
  EXPENSES_SUMMARY = "expenses/summary",
  EXPENSE_PAYMENT_METHODS = "expense-payment-methods",
  PROJECT_UNITS = "project-units",
  VOUCHER_OCR = "expenses/voucher-ocr",
  APPROVAL_MODEL_BY_CUSTOMER = "approval-model-by-customer",
  THEME_DATA = "theme-data",
  MAP_ADDRESSES = "map-addresses",
  EXPENSE_CARDS = "expense/cards",
  EXPENSE_CARD = "expense/card",
  EXPENSE_MAIN_BALANCE = "expense/main-balance",
  EXPENSE_CARDS_BALANCE = "expense/cards-balance",
  EXPENSE_CARD_GROUPS = "expense/card-groups",
  EXPENSE_MCC_GROUPS = "expense/mcc-groups",
  CUSTOMER_BANK_ACCOUNTS = "customer/bank-accounts",
  ADVANCES_SUMMARY = "advances/summary",
  MANUAL_EMISSION_PAYMENT_METHODS = "manual-emission-payment-methods",
  FINANCIAL_PENDINGS = "financial-pendings",
  FAKE_SEARCH_STATUS = "fake-search/status",
  SYSTEM_ANNOUNCEMENTS = "system-announcements",
  SYSTEM_ANNOUNCEMENT_FIXED = "system-announcements/fixed",
}
